export const PAUSED_OPEN_STATE = "pause";
export const PAUSED_PURCHASE_MESSAGE = "사이트 운영이 일시정지되었습니다. 새 구매는 현재 이용할 수 없습니다.";

const PURCHASE_ROUTE_PREFIXES = [
  "/reservation",
  "/package",
  "/ticket",
  "/shop",
  "/order",
  "/private-package",
  "/order-shop",
  "/order-ticket-multi",
  "/add-options",
  "/add-options-detail",
  "/add-options-order",
  "/amazingpass/order",
  "/lodging-package",
  "/table-order",
];

const PAUSE_ALLOWED_ROUTE_PREFIXES = [
  "/order-done",
  "/order-done-multi",
  "/order-fail",
  "/add-options-order-done",
  "/my-page",
  "/login",
  "/phone-login",
  "/admin-login",
  "/kakao",
  "/auth/kakao-phone-input",
];

export function shouldShowPauseBanner(siteDetail) {
  return siteDetail?.open_state === PAUSED_OPEN_STATE;
}

export function isPurchaseRoute(pathname = "") {
  return PURCHASE_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function canAccessRouteDuringPause(pathname = "") {
  if (pathname === "/" || pathname === "") {
    return true;
  }
  if (PAUSE_ALLOWED_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return true;
  }
  return !isPurchaseRoute(pathname);
}
